// LiveStreamChatroomGiftItem.js
'use strict';
import { connect } from 'react-redux';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getListData from '../selector/getListData.js';
import getGiftData from '../selector/getGiftData.js';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';

import LiveStreamChatroomGiftItem from '../component/LiveStreamChatroomGiftItem.jsx';
import { GiftUiType } from '../resource/giftConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.GIFT_NOTICE;
  const giftNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const giftNoticeId = giftNoticeIds[0];
  const giftNoticeSelectPath = [streamId, noticeType, giftNoticeId];
  const giftId = getLiveStreamData(state, giftNoticeSelectPath, 'giftId');
  const giftImage = giftId ? getGiftData(state, giftId, 'image') : '';

  const uiType = getGiftData(state, giftId, 'uiType');
  const isAnimationGift = uiType === GiftUiType.APNG;
  const isPagGift = uiType === GiftUiType.PAG;

  return {
    giftImage,
    isPagGift,
    isAnimationGift,
    shouldShowMainAsset: getLiveStreamData(
      state,
      giftNoticeSelectPath,
      'shouldShowMainAsset'
    ),
  };
};

export default connect(mapStateToProps, null)(LiveStreamChatroomGiftItem);
